export const SHIFT_CLOSE_SUMMARY_TYPES = ['compact', 'detailed'] as const

export type ShiftCloseSummaryType = (typeof SHIFT_CLOSE_SUMMARY_TYPES)[number]

export const DEFAULT_SHIFT_CLOSE_SUMMARY_TYPE: ShiftCloseSummaryType = 'detailed'

/** Missing, null, and unknown legacy values behave as detailed. */
export function normalizeShiftCloseSummaryType(value: unknown): ShiftCloseSummaryType {
  if (typeof value !== 'string') return DEFAULT_SHIFT_CLOSE_SUMMARY_TYPE
  return value.trim().toLowerCase() === 'compact' ? 'compact' : DEFAULT_SHIFT_CLOSE_SUMMARY_TYPE
}
